import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TransportationGoodsQuoterStoreService } from '../../../store/transportation-goods-quoter-store.service';
import { QuoterStoreService } from '@webapp/quoter/store/quoter-store.service';
import { formatCurrency } from '@webapp/core';
import { ResumeItemComponent } from '@webapp/core/ui/components/resume-item/resume-item.component';
import { IResumeItem } from '@webapp/quoter/interfaces/quoter.interface';

@Component({
  selector: 'app-transportation-goods-resume',
  imports: [ResumeItemComponent],
  providers: [DatePipe],
  templateUrl: './transportation-goods-resume.component.html',
  styleUrl: './transportation-goods-resume.component.scss',
})
export class TransportationGoodsResumeComponent {
  private transportationGoodsStateService = inject(
    TransportationGoodsQuoterStoreService
  );
  private quoterState = inject(
    QuoterStoreService
  );
  readonly transportationGoodsState =
    this.transportationGoodsStateService.state.asReadonly();
  datePipe = inject(DatePipe);

  items: IResumeItem[] = [
    {
      title: 'Mercaderías',
      text: this.transportationGoodsState().insurable.goodsText,
    },
    {
      title: 'Usado',
      text: (this.transportationGoodsState().insurable.usedGoods) ? 'Si' : 'No',
    },
    {
      title: 'Desde',
      text: `${this.transportationGoodsState().insurable.placeOfOrigin}`,
    },
    {
      title: 'Hasta',
      text: `${this.transportationGoodsState().insurable.placeOfDestination}`,
    },
    {
      title: 'Fecha',
      text: `${this.datePipe.transform(
        this.transportationGoodsState().insurable.startDate,
        'dd/MM/yyyy'
      )}`,
    },
    {
      title: 'Suma asegurada',
      text: formatCurrency(this.transportationGoodsState().insurable.goodsPrice, this.quoterState.state().currency)
    },
  ];
}
